/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:29px;height:29px;border-radius:50%;box-shadow:inset 1px 1px 3px 0 rgba(0,0,0,.1);border:1px solid #c8c8c8;cursor:pointer}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.tick[_ngcontent-%COMP%]{display:none;width:25px;height:25px;border:8px solid #007ac9;position:absolute;top:1px;left:1px;border-radius:50%}input[_ngcontent-%COMP%]:checked ~ .tick[_ngcontent-%COMP%]{display:block}\n/*# sourceMappingURL=round-radio.component.css.map*/"];
export { styles as styles };
